import {
  API_ERROR,
  VEND_PO_DOC_REPORT,
  VEND_PO_DOC_REPORT_SUCCESS,
  PO_DOC_PDF,
} from "./actionTypes";
// PO  Reports

export const getVendPODocReport = (POToken) => {
  return {
    type: VEND_PO_DOC_REPORT,
    payload: { POToken },
  };
};
export const VendPODocReportSuccessful = (response) => {
  return {
    type: VEND_PO_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
export const PurchaseOrderPdf = (POPdf) => {
  return {
    type: PO_DOC_PDF,
    payload: { POPdf },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
